import { data } from '../../svg/Home/data';
import { makeIcon } from '../makeIcon';

export const Home = makeIcon(data, 'home', 'Home');

export default Home;
